// extracted by mini-css-extract-plugin
export default {"container":"LatestListings_container__+bOju","title":"LatestListings_title__+whrT","spinnerContainer":"LatestListings_spinnerContainer__8-2Bq"};